import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { FlashController } from 'src/app/flash-payment/flash-payment-core/services/flash-controller.service';
import {MatDialog} from "@angular/material/dialog";
import {DialogConfirmComponent} from "../../dialog-confirm/dialog-confirm.component";
import {DialogContinueComponent} from "./dialog-continue/dialog-continue.component";

@Component({
  selector: 'app-credit-card',
  templateUrl: './credit-card.component.html',
  styleUrls: ['../way-to-pay.component.sass']
})
export class CreditCardComponent implements OnInit {
  @Input() cantShowArrows: boolean;
  @Input() openForm: boolean;
  @Output() action = new EventEmitter<any>();
  constructor(public flashPaymentService: FlashController,  public dialog: MatDialog) { }

  ngOnInit(): void {
  }

  changeIcon() {
    this.openForm = !this.openForm;
    if (this.flashPaymentService.controller.tokenInstrumentId !== 0) {
      this.flashPaymentService.controller.tokenInstrumentId = 0;
      this.flashPaymentService.controller.cardSelected = null;
      this.flashPaymentService.selectCard({id: -1});
    }

    this.action.emit(true);

  }

  pay() {
    this.openDialog();
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(DialogContinueComponent, {
      width: 'auto'
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
      if (result) {
        this.flashPaymentService.pay()
      }
    });
  }

}


